import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getMultiStageReport } from '../../graphql/queries/getMultiStageReport.query';
import { getUserFeatureAttributes } from '../../graphql/queries/getUserFeatureAttributes.query';
import {
    getAssessmentSequence as GetAssessmentSequenceResponse,
    getAssessmentSequenceVariables as GetAssessmentSequenceInput,
    getMultiStageReport as GetMultiStageReportResponse,
    getMultiStageReportVariables as GetMultiStageReportInput,
    getStandardsMetadata as GetStandardsMetadataResponse,
    getStandardsMetadataVariables as GetStandardsMetadataInput,
    getUserFeatureAttributes as GetUserFeatureAttributesResponse,
} from './../../../../schema/graphql-types';
import { getAssessmentSequence } from './../../../../src/app/graphql/queries/getAssessmentSequence.query';
import { getStandardsMetadata } from './../../../../src/app/graphql/queries/getStandardsMetadata.query';

@Injectable({
    providedIn: 'root',
})
export class MultiStageAssignmentReportDataService {
    constructor(private readonly apollo: Apollo) {}

    getMultiStageReport(input: GetMultiStageReportInput): Observable<GetMultiStageReportResponse> {
        return this.apollo
            .query<GetMultiStageReportResponse>({
                query: getMultiStageReport,
                variables: input,
            })
            .pipe(
                map((data) => {
                    return data.data;
                }),
            );
    }

    getAssessmentSequence(input: GetAssessmentSequenceInput): Observable<GetAssessmentSequenceResponse> {
        return this.apollo
            .query<GetAssessmentSequenceResponse>({
                query: getAssessmentSequence,
                variables: input,
            })
            .pipe(map(({ data }) => data));
    }

    getStandardMetadata(input: GetStandardsMetadataInput): Observable<GetStandardsMetadataResponse> {
        return this.apollo
            .query<GetStandardsMetadataResponse>({
                query: getStandardsMetadata,
                variables: input,
            })
            .pipe(map(({ data }) => data));
    }

    getUserFeatureAttributes(): Observable<GetUserFeatureAttributesResponse> {
        return this.apollo
            .query<GetUserFeatureAttributesResponse>({
                query: getUserFeatureAttributes,
            })
            .pipe(map(({ data }) => data));
    }
}
